import React from 'react';
import _ from 'underscore';

import {assert} from 'Asserts';
import Col from 'ui-library/bs/Col';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {Optional, InputChangeEvent} from 'util/Types';

interface PrimerRowIntervalProps {
  inputs: Array<{
    value: string;
    onChange: (e: InputChangeEvent) => void;
    placeholder: string | number | null;
  }>;
  selection: {
    start: number;
    end: Optional<number>;
  };
  setFromSelection: (start: string, end: string) => void;
}

class PrimerRowInterval extends React.Component<PrimerRowIntervalProps> {
  disableSetFromSelection = (): boolean => this.props.selection.end == null;

  setFromSelection = (): void => {
    const start = String(this.props.selection.start);
    const end = String(this.props.selection.end);
    this.props.setFromSelection(start, end);
  };

  render(): JSX.Element {
    assert(this.props.inputs.length === 2, 'PrimerRowInterval should have exactly 2 inputs');
    return (
      <div>
        {Array.from(this.props.inputs).map((input, key) => (
          <Col md={3} key={key}>
            <input
              {
                // TODO: refactor _.extend to be type-explicit
                ..._.extend({type: 'text'}, input) // eslint-disable-line no-restricted-syntax
              }
            />
          </Col>
        ))}
        <Col md={4}>
          <Button
            buttonStyle={ButtonStyle.TERTIARY_GRAY}
            size={ButtonSize.SMALL}
            onClick={this.setFromSelection}
            disabled={this.disableSetFromSelection()}
            text="Use selection"
          />
        </Col>
      </div>
    );
  }
}

export default PrimerRowInterval;
